const Typography = {
  fontFamily: `'Brandon Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'${''}`,
  fontSize: '20px',
  brandOne: {
    size: '74px',
    height: '35px'
  },
  brandTwo: {
    size: '64px',
    height: '60px'
  },
  brandThree: {
    size: '38px',
    height: '39px'
  },
  headerOne: {
    size: '42px',
    height: '28px'
  },
  headerTwo: {
    size: '28px',
    height: '32px'
  },
  headerThree: {
    size: '24px',
    height: '28px'
  },
  headerFour: {
    size: '22px',
    height: '28px'
  },
  headerFive: {
    size: '20px',
    height: '28px'
  },
  headerSix: {
    size: '18px',
    height: '28px'
  },
  headerSeven: {
    size: '16px',
    height: '28px'
  },
  headerEight: {
    size: '14px',
    height: '28px'
  },
  headerNine: {
    size: '12px',
    height: '28px'
  },
  bodyOne: {
    size: '26px',
    height: '32px'
  },
  bodyTwo: {
    size: '18px',
    height: '24px'
  },
  bodyThree: {
    size: '16px',
    height: '24px'
  },
  bodyFour: {
    size: '14px',
    height: '20px'
  },
  bodyFive: {
    size: '12px',
    height: '18px'
  }
};

export default Typography;
